export {
  ContentPromo,
  type ContentPromoPost,
  type ContentPromoProps,
} from "./ContentPromo";
